import React from 'react';
import { MDText } from 'i18n-react';

import type { VehicleListQuery } from 'Components/Account/AccountPage.types';
import cypressIds from 'Components/cypress_ids.json';
import { applyCypressData } from 'Utilities/helpers';
import { isQueryLoading } from 'Utilities/helpers/reactQuery.helpers';

import LocalTexts from './AccountResultsCount.texts.json';

import styles from './AccountResultsCount.module.scss';

const LocalT = new MDText(LocalTexts);

type AccountResultsCountProps = Pick<VehicleListQuery, 'queryStatus' | 'isPreviousData'> & {
	count: number;
	keyword?: string;
};

const AccountResultsCount: React.FC<AccountResultsCountProps> = ({ count, isPreviousData, keyword, queryStatus }) => {
	const isLoading = isQueryLoading(queryStatus) || isPreviousData;
	const searchingMessage = keyword ? LocalT.translate('searching') : '';
	const resultsText = isLoading
		? searchingMessage
		: LocalT.translate(`resultsCount.${count === 1 ? 'singular' : 'plural'}`, { count });

	return (
		<span className={styles.resultsCount} {...applyCypressData(cypressIds.text.accountResultsCount)}>
			{resultsText}
		</span>
	);
};

export default AccountResultsCount;
